import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ApiResponseModel } from '../../shared/api-response.model';
import { Core2Config } from '../../shared/core2Config';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { ItemMappingContainerModel } from '../../../../../../models/aggregates/item-mapping/item-mapping-container.model';
import { Pagination } from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class ItemMappingService extends BaseApiTemplateService<ItemMappingContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.T2T_DOMAIN_URL_PREFIX + Core2Config.CONFIG_PREFIX + 'fi-item-linking/login-guest-ep';
    this.httpClient = http;
  }
  getTenantItems(tenantHdr: ItemMappingContainerModel, pagination: Pagination, visa: ApiVisa): Observable<ApiResponseModel<ItemMappingContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + tenantHdr + '/fi-items/query?' + pagination.getQueryKeyValues();
    }
    return this.httpClient.get<ApiResponseModel<ItemMappingContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }
}
